import { Auth, Config } from 'olympe'
import { reasonCodes } from './_enums';
import { formatFilterOptionsForAPI, SFFilterType } from '../shared/_filters';
import { getUserPlants } from '../shared/_helpers';

export const getLookupDataSF = async (entity, filters, search) => {

    // Options that do not need to be fetched from the API
    if (entity === SFFilterType.REASON_CODE.key) {
        return [reasonCodes['UM'], reasonCodes['BD'], reasonCodes['RF'], reasonCodes['AM']];
    }
    if (entity === SFFilterType.PLANT.key) {
        return getUserPlants().map((plant) => {
            return {
                id: plant.plantID,
                description: plant.market + ' - ' + plant.plantID + ' - ' + plant.plantDescription
            };
        });
    }

    /**
     * Check if values are given for the given filter key
     *      and transform those values to string expected by the api
     * Returns empty array if the filter types equals the entity, or if the value is undefined.
     *
     * @param {SFFilterType} type
     * @return {Array<string>}
     */
    const getSelectedFilters = (type) => {
        return (filters[type.key] && entity !== type.key) ? formatFilterOptionsForAPI(type.key, filters[type.key].values) : [];
    };

    const rootUrl = Config.getParameter('filter_path');
    const proxyUrl = Config.getParameter('http_proxy_path');
    const access_token = sessionStorage.getItem("ms_auth_token");
    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`
        },
        opperation: 'POST',
        payload: {
            entity: entity,
            searchValue: search,
            plants: getSelectedFilters(SFFilterType.PLANT),
            materials: getSelectedFilters(SFFilterType.MATERIAL),
            materialType: getSelectedFilters(SFFilterType.MATERIAL_TYPE),
            specifications: getSelectedFilters(SFFilterType.SPECIFICATION),
            reasonCode: getSelectedFilters(SFFilterType.REASON_CODE),
            'modified-by': getSelectedFilters(SFFilterType.MODIFIED_BY), // filtering by modified-by has not effect on the lookup endpoint
            materialGroup: getSelectedFilters(SFFilterType.MATERIAL_GROUP),
            spendCategory1: getSelectedFilters(SFFilterType.SPEND_CAT_L1),
            psName: getSelectedFilters(SFFilterType.PS_NAME),
            pmName: getSelectedFilters(SFFilterType.PM_NAME),
            tastyClassification: getSelectedFilters(SFFilterType.TASTY_CLASSIFICATION),
        },
    }

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            body: JSON.stringify(body),
        })

        if (!request.ok) {
            throw new Error(`Error ${request.status}`)
        }
        const result = await request.json()
        return result
    } catch (error) {
        return {
            error: true,
            message: error.message,
        }
    }
}
